// extracted by mini-css-extract-plugin
module.exports = {"message":"FileMessageSalesSubmissionInformation_message__2t5a1","message-success":"FileMessageSalesSubmissionInformation_message-success__3OvAo"};